var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationTransparentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00008 11.2292C7.00008 11.2292 10.6459 8.75 10.6459 6.41667C10.6459 4.375 8.93308 2.77083 7.00008 2.77083C5.06708 2.77083 3.35425 4.375 3.35425 6.41667C3.35425 8.75 7.00008 11.2292 7.00008 11.2292ZM7 7.72917C7.72487 7.72917 8.3125 7.14154 8.3125 6.41667C8.3125 5.69179 7.72487 5.10417 7 5.10417C6.27513 5.10417 5.6875 5.69179 5.6875 6.41667C5.6875 7.14154 6.27513 7.72917 7 7.72917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTransparentIcon);
export default __webpack_public_path__ + "static/media/locationTransparentIcon.8794a289aa4f17b56f15b947ce6d7b84.svg";
export { ForwardRef as ReactComponent };